<template>
  <div>
    <div class="htmlBox">
      <h4 class="title">重置密码</h4>
      <article class="tips">请填写以下信息就可以重置密码哦</article>
      <div class="userinfo">
        <ul>
          <li>
            <p>用户名</p>
            <input type="tel" placeholder="请输入用户名" v-model="userName" />
          </li>
          <li>
            <p>手机号</p>
            <input type="tel" placeholder="请输入手机号" v-model="phone" />
          </li>
          <li>
            <p>图片验证码</p>
            <input
              class="w200"
              type="num"
              placeholder="请输入图片验证码 "
              v-model="imgcode"
            />
            <img :src="codeImage" @click="getCaptcha()" alt="" />
          </li>
          <li>
            <p>短信验证码</p>
            <input
              class="w200"
              type="num"
              name=""
              id=""
              value=""
              placeholder="请输入验证码"
              v-model="code"
            />
            <em @click="getcode()" v-if="sign == false">发送验证码</em>
            <em v-else style="background:#BBBBBB;color:#fff "
              >{{ codehtml }}S</em
            >
          </li>
          <li>
            <p>新密码</p>
            <input
              class="w200"
              type="password"
              placeholder="请输入新密码"
              v-model="pwd"
            />
          </li>
          <li>
            <p>确认密码</p>
            <input
              class="w200"
              type="password"
              placeholder="请再次输入新密码"
              v-model="pwdtwo"
            />
          </li>
        </ul>
      </div>

      <div class="xieyi" v-if="showHide">
        <Iconfont
          name="iconselected"
          class="icon"
          size="0.6rem"
          color="#FD3E3E"
          v-if="isProtocol"
          @click="protocolFg"
        />
        <Iconfont
          @click="protocolFg"
          name="iconweixuanzhong"
          class="icon"
          size="0.6rem"
          color="#999"
          v-else
        />
        <span @click="protocolFg">已阅读同意</span>
        <b>
          <span @click="goPath('/userAgreement')">《用户服务协议》</span
          ><span @click="goPath('/serviceAgreement')">《隐私保护政策》</span></b
        >
      </div>
      <button
        :disabled="btnState == false"
        :class="{ btnBg: btnState }"
        @click="sure()"
        v-if="showHide"
      >
        重置
      </button>
    </div>
  </div>
</template>
<script>
import Iconfont from '@/components/iconfont.vue'
import { sendRequest } from '@/assets/public'
import { Toast, Dialog } from 'vant'

export default {
  components: { Iconfont },
  data() {
    return {
      isProtocol: true,
      userName: '',
      phone: '',
      imgcode: '',
      code: '',
      invitaCode: '',
      pwd: '',
      pwdtwo: '',
      codehtml: 60,
      sign: false,
      codeImage: '',
      codeKey: '',
      setTime: true,

      docuHeight: document.documentElement.clientHeight,
      showHeight: document.documentElement.clientHeight,
      showHide: true,
    }
  },
  created() {
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight
      })()
    }
    this.getCaptcha()
  },
  methods: {
    //   协议
    protocolFg() {
      this.isProtocol = !this.isProtocol
    },
    goPath(url) {
      this.$router.push(url)
    },
    // 获取img
    async getCaptcha() {
      if (!this.setTime) {
        return
      }
      this.setTime = false
      let res = await sendRequest('user/getCaptcha', {})
      if (res.status == 200) {
        this.codeImage = res.content.img
        this.codeKey = res.content.key
        setTimeout(() => {
          this.setTime = true
        }, 500)
      }
    },
    // 发送验证码
    async getcode() {
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast('手机号码有误')
        return false
      } else {
        if (this.imgcode == '') {
          Toast('请输入图形验证码')
          return
        }
        let params = {
          phone_mob: this.phone,
          captcha_code: this.imgcode,
          key: this.codeKey,
        }
        let res = await sendRequest('user/sendNoCodeSms', params)
        if (res.status == 200) {
          this.codehtml = 60
          this.sign = true
          let tim = setInterval(() => {
            this.codehtml = this.codehtml - 1
            if (this.codehtml <= 0) {
              clearInterval(tim)
              this.sign = false
              return false
            }
          }, 1000)
          this.time = tim
        } else {
          Toast(res.msg)
        }
      }
    },
    async sure() {
      let tips = false // 提示信息

      if (this.pwd == '') {
        tips = '请输入密码'
      }
      if (this.pwdtwo == '') {
        tips = '请再次输入密码'
      }
      if (this.pwd != this.pwdtwo) {
        tips = '两次输入密码不一致'
      }
      if (this.code == '') {
        tips = '请输入短信验证码'
      }
      if (this.imgcode == '') {
        tips = '请输入图形验证码'
      }
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        tips = '手机号码有误'
      }
      if (this.userName == '') {
        tips = '请输入用户名'
      }
      if (!this.isProtocol) {
        tips = '请先同意协议'
      }
      if (tips) {
        Toast(tips)
        return
      }
      let { content, status, msg } = await sendRequest('user/forgetpwd', {
        user_name: this.userName,
        sms_code: this.code,
        b2bpwd: this.pwd,
        phone_mob: this.phone,
      })
      if (status == 200) {
        Toast('修改成功')
        setTimeout(() => {
          this.$router.replace('/login')
        }, 300)
      } else {
        Toast(msg)
      }
    },
  },
  computed: {
    btnState() {
      console.log(
        this.pwd != '',
        this.pwdtwo != '',
        this.imgcode != '',
        this.pwd == this.pwdtwo,
        this.code != '',
        this.userName != '',
        this.isProtocol
      )
      return (
        this.userName != '' &&
        this.phone != '' &&
        this.pwd != '' &&
        this.pwdtwo != '' &&
        this.pwd == this.pwdtwo &&
        this.code != '' &&
        this.imgcode != '' &&
        this.isProtocol
      )
    },
  },
  watch: {
    showHeight() {
      if (this.docuHeight > this.showHeight) {
        this.showHide = false
      } else {
        this.showHide = true
      }
    },
  },
}
</script>
<style scoped>
.xieyi {
  position: absolute;
  bottom: 3.6rem;
  left: 0;
  width: 100%;
  font-size: 0.56rem;
  text-align: center;
}

.xieyi b {
  color: #fd3e3e;
}
.xieyi .iconfont {
  margin-right: 0.4rem;
}

/*button禁用时的背景颜色*/
button {
  width: 13.6rem;
  height: 2rem;
  background: rgba(221, 221, 221, 1);
  border-radius: 0.2rem;
  position: absolute;
  bottom: 0.8rem;
  left: 0.7rem;
  line-height: 2rem;
  font-size: 0.6rem;
  color: #fff;
  border: none;
}

/*button可用时的背景颜色*/
.btnBg {
  width: 13.6rem;
  height: 2rem;
  border-radius: 0.2rem;
  position: fixed;
  bottom: 0.8rem;
  left: 0.7rem;
  line-height: 2rem;
  font-size: 0.6rem;
  color: #fff;
  background: #fd3e3e;
  border: none;
}

.htmlBox {
  height: 100vh;
  display: block;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}

.title {
  font-size: 0.96rem;
  color: #333333;
  font-weight: normal;
  margin: 1.4rem 0 0.6rem;
  text-align: center;
}

.tips {
  color: #999999;
  font-size: 0.56rem;
  margin: 0;
  text-align: center;
}

.userinfo {
  width: 15rem;
  padding-top: 1.2rem;
}

.userinfo ul {
  padding: 0 0.8rem;
}

.userinfo ul li {
  height: 1.6rem;
  line-height: 1.6rem;
  padding-top: 0.4rem;
  border-bottom: 1px solid #eeeeee;
  overflow: hidden;
}

.userinfo ul li p {
  float: left;
  font-size: 0.56rem;
  color: #333333;
  width: 3rem;
}

.userinfo ul li input {
  width: 8rem;
  float: left;
  border: none;
  font-size: 0.56rem;
  padding-left: 0.4rem;
  line-height: 1.5rem;
}

.userinfo ul li img {
  display: block;
  width: 3.6rem;
  height: 1.4rem;
  float: right;
}

.userinfo ul li input.w200 {
  width: 6rem !important;
}

.userinfo ul li em {
  width: 3.6rem;
  height: 1.4rem;
  background: #fd3e3e;
  border-radius: 0.2rem;
  color: #fff;
  line-height: 1.4rem;
  float: right;
  font-size: 0.56rem;
  font-style: normal;
  text-align: center;
}

.sure_btn {
  width: 13.6rem;
  height: 2rem;
  background: rgba(221, 221, 221, 1);
  border-radius: 0.2rem;
  position: absolute;
  bottom: 1.6rem;
  left: 0.7rem;
  line-height: 2rem;
  font-size: 0.6rem;
  color: #fff;
}

.active {
  background: #fd3e3e !important;
}
</style>
